import { makeStyles } from '@lifeomic/chroma-react/styles';
import { alpha } from '@mui/material/styles';

export const OFFSET_CONTENT_HEIGHT = 264;

export const useStyles = makeStyles(theme => ({
  layoutContainer: {
    marginBottom: 0,
  },
  tabsControls: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
  },
  tabsList: {
    marginBottom: 0,
  },
  tabPanel: {
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    overflow: 'hidden',
  },
  tabsContainer: {
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column' as const,
  },
  mainContent: {
    marginTop: theme.spacing(2),
    height: `calc(100vh - ${theme.pxToRem(OFFSET_CONTENT_HEIGHT)})`,
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    minHeight: 0,
  },
  skeleton: {
    height: `calc(100vh - ${theme.pxToRem(OFFSET_CONTENT_HEIGHT)})`,
  },
  loadingContainer: {
    backgroundColor: theme.palette.black[50],
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
  },
  mainContentEmpty: {
    backgroundColor: theme.palette.common.white,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    paddingBottom: theme.spacing(6),
  },
  emptyPaper: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.boxShadows.table,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: theme.spacing(6),
  },
  bodyContent: {
    backgroundColor: theme.palette.common.white,
    height: '100%',
    display: 'flex',
    minHeight: 0,
    width: '100%',
    overflow: 'hidden',
  },
  tableWrapper: {
    width: '100%',
    '& table': {
      boxShadow: 'none',
    },
    '& tr[data-selected="true"]': {
      backgroundColor: `${alpha(theme.palette.graphite.main, 0.05)} !important`,
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: theme.pxToRem(4),
        height: '100%',
        backgroundColor: theme.palette.primary.main,
        zIndex: 1,
      },
    },
  },
  tableScrollContainer: {
    overflowY: 'auto',
    overflowX: 'auto',
    flex: 1,
    height: '100%',
    maxWidth: theme.pxToRem(600),
    minHeight: 0,
    '& table thead': {
      display: 'none',
    },
  },
  readingPane: {
    backgroundColor: theme.palette.black[50],
    borderLeft: `1px solid ${theme.palette.divider}`,
    flex: 1.5,
    flexDirection: 'column' as const,
    height: '100%',
    gap: theme.spacing(2),
    overflow: 'auto',
    padding: theme.spacing(2),
  },
  detailPaper: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.boxShadows.table,
    flex: 1,
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    minHeight: 0,
    overflowY: 'auto',
  },
  readingPaneHeader: {
    backgroundColor: theme.palette.common.white,
    flexDirection: 'column' as const,
    justifyContent: 'space-between',
    padding: `${theme.spacing(1)} ${theme.spacing(3)} ${theme.spacing(
      0,
    )} ${theme.spacing(3)}`,
    position: 'sticky' as const,
    top: 0,
    zIndex: 1,
  },
  divider: {
    margin: `${theme.spacing(1)} ${theme.spacing(-3)} 0`,
    width: `calc(100% + ${theme.spacing(6)})`,
  },
  detailBody: {
    padding: theme.spacing(3),
  },
  detailMarkdownViewer: {
    padding: 0,
    '& .public-DraftEditor-content': {
      fontSize: theme.pxToRem(14),
      lineHeight: theme.pxToRem(20),
    },
    '& .public-DraftStyleDefault-block': {
      margin: 0,
    },
  },
}));
